// libraries
import React from 'react'
import clsx from 'clsx'
import Section from '../Section'
import RichText from '../RichText'

// interface
export interface Props {
    content?: string
    bgColor?: 'primary' | 'secondary' | 'tertiary' | 'tertiary-10' | 'white'
    className?: string
}

export default function TextBlock({
    content,
    bgColor,
    className
}: Props) {
    return (
        <Section
            className={clsx('text-block', className)}
            paddingTop='medium'
            paddingBottom='medium'
            bgColor={bgColor}
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2'>
                        <RichText content={content} />
                    </div>
                </div>
            </div>
        </Section>
    )
}
